import { render, staticRenderFns } from "./DuplicateLeadsListModal.vue?vue&type=template&id=e06960a8&scoped=true&"
import script from "./DuplicateLeadsListModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateLeadsListModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateLeadsListModal.vue?vue&type=style&index=0&id=e06960a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06960a8",
  null
  
)

export default component.exports